import { useTranslation } from "react-i18next";

export const useRequestMonitor = () => {
  const { t } = useTranslation();

  const monitorRequest = (promise, dialog = null) => {
    const startTime = Date.now();
    let dialogShown = false;
    let timeoutIds = [];
    
    const clearAllTimeouts = () => {
      timeoutIds.forEach(id => clearTimeout(id));
      timeoutIds = [];
    };
    
    const timeout300ms = setTimeout(() => {
      if (dialog && !dialogShown) {
        dialogShown = true;
        dialog
          .withTitle(t("Connection problem detected"))
          .withMessage(t("We are trying again"))
          .withButtonText(t("Waiting"))
          .show();
      }
    }, 3000);
    timeoutIds.push(timeout300ms);
    
    const timeout600ms = setTimeout(() => {
      if (dialog && dialogShown) {
        dialog
          .withTitle(t("Could not establish connection"))
          .withMessage(t("Check stable internet"))
          .withButtonText(t("Waiting"))
          .show();
      }
    }, 600);
    timeoutIds.push(timeout600ms);
    
    return promise
      .then((response) => {
        clearAllTimeouts();
        
        if (dialogShown && dialog) {
          dialog.close();
        }
        
        return response;
      })
      .catch((error) => {
        clearAllTimeouts();
        
        if (dialogShown && dialog) {
          dialog.close();
        }
        
        throw error;
      });
  };

  return { monitorRequest };
};
